import { inject, Injectable } from "@angular/core";
import * as Sentry from "@sentry/angular-ivy";
import { User } from "../../auth/models/user.model";
import { environment } from "../../../../environments/environment";
import { buildVersion } from "../../../../build-version";
import { TicketService } from "./ticket.service";
import { LocalStorageService } from "../../../shared/services/local-storage.service";

@Injectable({
  providedIn: "root",
})
export class SentryService {
  ticketService = inject(TicketService);
  localStorageService = inject(LocalStorageService);
  constructor() {
    window["sentryService"] = this;
  }

  initSentry() {
    if (this.localStorageService.getWithTTL("recording")) {
      this.ticketService.startRecording();
    }

    if (!environment.sentryEnable) {
      return;
    }
    Sentry.init({
      // DSN lu depuis l'environnement (prod/qualif → instance auto-hébergée OVH France
      // `sentry.admin-op.ovh`). Ne PAS coder le DSN en dur : un DSN cloud US enverrait
      // les données d'erreur (PII) hors UE.
      dsn: environment.sentryDsn,
      environment: window.location.hostname,
      sendDefaultPii: true,
      // Single source = package.json (via build-version.prod.ts). Must match the release
      // uploaded by build-macos.sh: justup-front@X.Y.Z (no commit suffix).
      release: `justup-front@${buildVersion.version}.${buildVersion.buildNumber}`,
      integrations: [
        Sentry.browserTracingIntegration(),
        // Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        "localhost",
        /^https:\/\/.*\.justup\.io/,
        /^https:\/\/.*\.kalif-op\.ovh/,
      ],

      // // Session Replay
      // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }

  configureSentry(user: User) {
    this.ticketService.load(user.username, user.email);
    const scope = Sentry.getCurrentScope();
    scope.setUser({ id: user.id, username: user.username, email: user.email });
    this.ticketService.initTracker(user);
  }

  captureException(error: any) {
    Sentry.captureException(error);
  }
}
